import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DIALOG_BOX_STYLE } from '../../../../_constants/styleConst';

type MessagePFRModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

/** PFRコード未設定時のメッセージダイアログ */
const MessagePFRModal: React.FC<MessagePFRModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          ...DIALOG_BOX_STYLE,
          width: 'fit-content',
          maxWidth: '600px',
          p: '2rem 2rem 1rem',
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          mr="5rem"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {t('MSG_NO_PFR_CODES')}
        </Typography>
        <Box display="flex" justifyContent="end" mt="1rem">
          <Button onClick={onClose} variant="contained">
            {t('BTN_OK')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default MessagePFRModal;
